import React from "react";
import i18n from "i18next";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getWindow } from "ssr-window";

import { api } from "@/utils/api";
import url from "@/utils/url";
import { authStateEnum } from "@/utils/enum";
import { isPOC } from "@/utils";
import { updateAgreementStatusInfo as updateAgreementStatusInfoDispatch } from "@/models/user";
import ConfirmHeader from "@/react-components/Confirm/Header";
import ConfirmBody from "@/react-components/Confirm/Body";
import ConfirmTips from "@/react-components/Confirm/Tips";
import ConfirmDiffBody from "@/react-components/Confirm/DiffBody";

class ConfirmInquirySection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
    this.redirectLP();
  }

  componentDidMount() {
    this.fetchData();
  }

  redirectLP = () => {
    const {
      history: { replace },
      location: { pathname },
      state,
    } = this.props;
    if (
      state === authStateEnum.notCertified &&
      !getWindow()?.sitecoreExternal?.isRegisterConfirm
    ) {
      if (pathname !== url.lp) {
        replace(url.lp);
      }
    }
  };

  fetchData = () => {
    const { state } = this.props;
    const name =
      state === authStateEnum.notCertified
        ? "getNoLoginInquiry"
        : "getLoginInquiry";
    api.agreement[name](
      state === authStateEnum.notCertified ? {} : { isSubUser: true }
    )
      .then((response) => {
        const list =
          state === authStateEnum.notCertified ? response : response?.list;
        if (list && list.length > 0) {
          let content = list.find((item) => !item.isPublish);
          if (!content) {
            content = list.find((item) => item.isPublish);
          }
          this.setState({
            data: { content, secureToken: response?.secureToken },
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  next = () => {
    const {
      history: { push },
      updateAgreementStatusInfo,
      state,
      authentication,
    } = this.props;
    if (state === authStateEnum.notCertified) {
      push(url.initialRegisterInfoEdit);
    } else {
      const { data } = this.state;
      const content = data?.content;
      if (isPOC()) {
        updateAgreementStatusInfo({
          agreementStatusInfo: {
            termsAgreementInfo: {
              termsOfServiceVer: "1.0",
              privacyPolicyVer: "1.0",
              contactFeatureVer: "1.0",
              bmSupportPlanTermsOfServiceVer: "1.0",
            },
          },
        });
      } else {
        api.agreement
          .updateLoginInquiry({
            userid: authentication?.accountId,
            secureToken: data?.secureToken,
            version: content?.version,
          })
          .then((response) => {
            api.user.getAgreementStatus().then((response1) => {
              updateAgreementStatusInfo({ agreementStatusInfo: response1 });
            });
          })
          .catch((error) => {
            console.error("error: " + error.message);
          });
      }
    }
  };

  render() {
    const { data } = this.state;
    // 課金-ADD-START
    const { contractInfo } = this.props;
    // 課金-ADD-END
    const content = data?.content;
    return (
      <div className="confirm-inquiry-container">
        <ConfirmHeader
          stepIndex={
            // 課金-UPD-START
            contractInfo?.isPayment ? 3 : 2
            // 課金-UPD-END
          }
        />
        {content ? (
          <React.Fragment>
            {!content.isPublish && (
              <React.Fragment>
                <ConfirmTips
                  className="confirm-inquiry-container-tips"
                  text={moment(content.updateDate).format(
                    i18n.t("TCCs0028_confirm_inquiry_tips")
                  )}
                />
                <ConfirmDiffBody
                  className="confirm-inquiry-container-diff-body"
                  title={i18n.t("TCCs0028_confirm_inquiry_diff_title")}
                  data={content}
                  // 課金-ADD-START
                  downloadUrl={i18n.t("inquiry_diff_version_download_url")}
                  // 課金-ADD-END
                />
              </React.Fragment>
            )}
            <ConfirmBody
              className="confirm-inquiry-container-body"
              title={i18n.t("TCCs0028_confirm_inquiry_content_title")}
              date={
                !content.isPublish &&
                moment(content.updateDate).format(i18n.t("common_date_after"))
              }
              content={content.contentText}
              checkboxText={i18n.t("TCCs0028_confirm_inquiry_checkbox_title")}
              onClick={this.next}
              // 課金-ADD-START
              downloadUrl={i18n.t("inquiry_applicable_version_download_url")}
              // 課金-ADD-END
            />
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    authentication: state?.user?.authentication,
    // 課金-ADD-START
    contractInfo: state?.user?.contractInfo,
    // 課金-ADD-END
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAgreementStatusInfo: (action) =>
      dispatch(updateAgreementStatusInfoDispatch(action)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmInquirySection));
